export default {
    getBadgeList(state) {
        return state.badgeList;
    },
};